(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fb-sticky-buy')) return;

    class FbStickyBuy extends HTMLElement {
      connectedCallback() {
        // Se mueve al <body> para que "fixed" funcione siempre, sin depender del contenedor
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        if (this.io1) return;
        this.pastTrigger = false;
        this.footerVisible = false;
        var isProduct = this.dataset.mode === 'product';
        var trigger = isProduct
          ? document.querySelector('.buy-buttons-block')
          : document.querySelector('.fb-hero-full__btn, .fb-hero__actions, main .shopify-section');
        var footer = document.querySelector('footer');

        if (trigger) {
          this.io1 = new IntersectionObserver((entries) => {
            var e = entries[0];
            this.pastTrigger = !e.isIntersecting && e.boundingClientRect.top < 0;
            this.update();
          });
          this.io1.observe(trigger);
        } else {
          this.pastTrigger = true;
        }

        if (footer) {
          this.io2 = new IntersectionObserver((entries) => {
            this.footerVisible = entries[0].isIntersecting;
            this.update();
          }, { rootMargin: '0px 0px 80px 0px' });
          this.io2.observe(footer);
        }

        if (isProduct) {
          var btn = this.querySelector('[data-fb-buy]');
          if (btn) {
            btn.addEventListener('click', function () {
              var main = document.querySelector('.buy-buttons-block [ref="addToCartButton"], .buy-buttons-block button[type="submit"][name="add"]');
              if (main) {
                main.click();
              } else {
                var block = document.querySelector('.buy-buttons-block');
                if (block) block.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            });
          }
        }
        this.update();
      }

      disconnectedCallback() {
        if (!this.io1 && !this.io2) return;
        if (this.io1) this.io1.disconnect();
        if (this.io2) this.io2.disconnect();
        this.io1 = this.io2 = null;
        document.body.classList.remove('fb-sticky-buy-on');
      }

      update() {
        var on = this.pastTrigger && !this.footerVisible;
        this.classList.toggle('is-visible', on);
        this.setAttribute('aria-hidden', on ? 'false' : 'true');
        this.querySelectorAll('a, button').forEach(function (el) {
          el.tabIndex = on ? 0 : -1;
        });
        document.body.classList.toggle('fb-sticky-buy-on', on);
      }
    }

    customElements.define('fb-sticky-buy', FbStickyBuy);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fb-story')) return;

    class FbStory extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fb-story__track');
        this.cards = Array.from(this.querySelectorAll('.fb-story__card'));
        this.dots = Array.from(this.querySelectorAll('.fb-story__dot'));
        var root = this.closest('.fb-story');
        if (root) {
          root.querySelectorAll('.fb-story__arrow').forEach((btn) => {
            btn.addEventListener('click', () => this.go(Number(btn.dataset.dir)));
          });
        }
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.mark());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.mark();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      step() {
        if (this.cards.length < 2) return this.track.clientWidth;
        return this.cards[1].offsetLeft - this.cards[0].offsetLeft;
      }

      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }

      mark() {
        var i = Math.round(this.track.scrollLeft / Math.max(1, this.step()));
        this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        var root = this.closest('.fb-story');
        if (!root) return;
        var max = this.track.scrollWidth - this.track.clientWidth - 4;
        var prev = root.querySelector('.fb-story__arrow[data-dir="-1"]');
        var next = root.querySelector('.fb-story__arrow[data-dir="1"]');
        if (prev) prev.disabled = this.track.scrollLeft <= 4;
        if (next) next.disabled = this.track.scrollLeft >= max;
      }
    }

    customElements.define('fb-story', FbStory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
